export const ISSUE_YEAR_ERROR = '분류 연도는 1000~9999 사이의 네 자리 숫자로 입력해주세요.';

export const parseIssueYear = value => (/^[1-9]\d{3}$/.test(String(value ?? '')) ? Number(value) : undefined);

export const formatIssueYear = value => {
  const year = parseIssueYear(value);
  return year === undefined ? '-' : year + '년';
};

export const getIssueYearOptions = (years = [], selectedYear) =>
  [...new Set([...(Array.isArray(years) ? years : []), selectedYear].map(parseIssueYear).filter(year => year !== undefined))].sort(
    (a, b) => b - a
  );

export const withIssueYear = (searchParams, value) => {
  const next = new URLSearchParams(searchParams);
  const year = parseIssueYear(value);
  if (year === undefined) next.delete('year');
  else next.set('year', String(year));
  next.set('page', '1');
  return next;
};
